/**
 * Material is forecast as one lump amount. Its share of the task-level estimate is
 * always derived from the two, never stored, so it can't go stale when either changes.
 */
export const getMaterialPercent = (amount: number, estimate: number) =>
  estimate > 0 ? Number(((amount / estimate) * 100).toFixed(2)) : 0;
